import { useEffect, useState } from 'react';
import '../App.css';
import '../styles/Modules.css';
import { FaInfoCircle, FaCheckCircle, FaExclamationCircle, FaEye, FaPlus, FaEdit, FaCircle, FaExclamationTriangle, FaCodeBranch, FaFlag, FaChevronRight } from 'react-icons/fa';
import { getDimensionsBySeason, getCommerceDimensionsBySeason } from '../services/dimension-service';
import { InfoPopup } from '../pop-ups/info-popup';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from '../shared/Dropdown';
import { useGetData, useGetToken } from '../hooks/custom-hooks';
import { LoadingModule } from './LoadingModule';


export function DimTablesPeekCard() {
    const navigate = useNavigate();

    const [isloading, setIsLoading] = useState(true);
    
    const dimTableList = useGetData(getCommerceDimensionsBySeason, null);

    useEffect(() => {
        if(dimTableList !== null) {
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
    },[dimTableList]);

    const [isHovered, setIsHovered] = useState(false);


    const handleClick = (dimTable, conflicts) => {
        navigate(`/Commerce/${dimTable}`);
    }

    if(isloading) {
        return (
            <LoadingModule/>
        );
    }

 return (
    <div className="dashboard-grid">
        {dimTableList.map((item) => {

            const hasErrors = item.totalErrors > 0;
            const hasWarnings = item.totalWarnings > 0;

            const StatusIcon = hasErrors
                ? FaExclamationCircle
                : hasWarnings
                ? FaExclamationTriangle
                : FaCheckCircle;

            return (
                <button
                    key={item.dimTableName}
                    className="dim-card"
                    onClick={() => handleClick(item.dimTableName)}
                >
                    <div className="dim-card-header">
                        <div className="title-left">
                            <StatusIcon
                                className={
                                    hasErrors
                                        ? "status-icon error"
                                        : hasWarnings
                                        ? "status-icon warning"
                                        : "status-icon success"
                                }
                            />
                            <span className="dim-card-title">
                                {item.displayName}
                            </span>
                        </div>
                        <FaChevronRight className="chevron" />
                    </div>

                    <hr className="card-divider" />
                    <div className="metrics">
                        <div className="metric">
                            <FaExclamationCircle className="metric-icon error" />
                            <span className="metric-number error">
                                {item.totalErrors}
                            </span>
                            <span className="metric-label">
                                Errors
                            </span>
                        </div>

                        <div className="metric">
                            <FaExclamationTriangle className="metric-icon warning" />
                            <span className="metric-number warning">
                                {item.totalWarnings}
                            </span>
                            <span className="metric-label">
                                Warnings
                            </span>
                        </div>

                        <div className="metric">
                            <FaCodeBranch className="metric-icon conflict" />
                            <span className="metric-number conflict">
                                {item.totalConflicts.toLocaleString()}
                            </span>
                            <span className="metric-label">
                                Conflicts
                            </span>
                        </div>
                    </div>
                </button>
            );
        })}
    </div>
);
}
